import BaseServiceWithUserTracking from "./base-with-user-tracking.service";

export type EmailResponse = {
  email: string
}

class CaseManagementService extends BaseServiceWithUserTracking {
  constructor() {
    super("CaseManagementMah");
    this.setBaseUrl("case-management");
  }

  sendMail(request: any, countryCode: string) {
    return this.createPromiseRequest(`/send-mail/${countryCode}`).post<boolean>(request);
  }

  getEmail(countryCode: string) {
    return this.createPromiseRequest(`/email/${countryCode}`).get<EmailResponse>();
  }
}

export default CaseManagementService;
